import { useState } from 'owa-react';
import TreeNode from 'owa-tree-node/lib/components/TreeNode';
import React from 'react';
import Strings from 'owa-folders-constants/lib/strings/LoadMore.locstring.json';
import loc from 'owa-localize';
import { Spinner } from '@fluentui/react-components';

export interface LoadMoreNodeProps {
    hasMoreData: boolean;
    shouldShowLoadingSpinner: boolean;
    offset: number;
    fetchMore: (offset: number) => Promise<void>;
}

export default function LoadMore(props: LoadMoreNodeProps): JSX.Element {
    const [loadMoreInProgress, setLoadMoreInProgress] = useState<boolean>(false);
    const { fetchMore, offset } = props;

    const onLoadMoreClicked = React.useCallback(async () => {
        setLoadMoreInProgress(true);
        await fetchMore(offset);
        setLoadMoreInProgress(false);
    }, [fetchMore, offset]);

    const shouldShowLoadingSpinner = props.shouldShowLoadingSpinner || loadMoreInProgress;

    return (
        <>
            {/* Loading spinner */}
            {shouldShowLoadingSpinner && <Spinner size="tiny" />}

            {/* Load more action button */}
            {!shouldShowLoadingSpinner && props.hasMoreData && (
                <TreeNode
                    displayName={loc(Strings.loadMoreFoldersAction)}
                    isCustomActionNode={true}
                    isRootNode={false}
                    key={'loadMore'}
                    onClick={onLoadMoreClicked}
                />
            )}
        </>
    );
}
